import { DEFAULT } from '../constants/wrappers';

export const wrappers = {
  [DEFAULT]: ({ children }) => <>{children}</>,
};
